<template>
  <div class="employeeDetail positionr" v-loading="loading">
    <!-- 面包屑导航区 -->
    <el-breadcrumb>
      <el-breadcrumb-item class="pointer" :to="{ path: '/employeemangent' }"
        >员工管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>员工管理详情</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 头像更换 -->
    <!-- <div class="avatar-uploader positiona">
      <el-upload
        action="http://120.55.60.66:8001/upload/uploadImage"
        :show-file-list="false"
        :limit="1"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img
          :src="imageUrl"
          class="avatar"
          onerror="this.src='https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2100401123,2895311668&fm=26&gp=0.jpg'"
        />
      </el-upload>
    </div> -->

    <!-- 内容主体 -->
    <div class="bgwhite bort">
      <el-row>
        <!-- tabbar -->
        <!-- <el-col :span="3">
          <div id="navigation">
            <ul>
              <li
                class="menu-item text-cut"
                v-for="(item, i) in tabs"
                :key="item"
                :class="seeThis == i ? 'active' : ''"
              >
                <a href="javascript:void(0)" @click="goAnchor(i)">{{ item }}</a>
              </li>
            </ul>
          </div>
        </el-col> -->
        <!-- tabbar对应内容 -->
        <!-- <el-col :span="24"> -->
        <div class="menu-content">
          <!-- 基本信息 -->
          <div class="p1" id="a1">
            <div class="header-search">
              <div class="title">
                <el-row>
                  <el-col :span="12">
                    <span class="line"></span>
                    基本信息
                  </el-col>
                  <el-col :span="12">
                    <div class="flex align-center justify-end h50">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="保存基本信息和扩展属性"
                        placement="bottom"
                      >
                        <el-button
                          type="primary"
                          size="small"
                          @click="submitForm('ruleForm')"
                          >保存</el-button
                        >
                      </el-tooltip>

                      <el-button
                        plain
                        size="small"
                        @click="route.push('/employeemangent')"
                        >取消</el-button
                      >
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="header-input">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="150px"
                class="ruleForm"
                size="mini"
              >
                <el-row>
                  <el-col :sm="24" :md="24" :lg="12">
                    <el-form-item label="登录名" prop="loginName">
                      <el-input v-model="ruleForm.loginName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :sm="24" :md="24" :lg="12">
                    <el-form-item label="密码" prop="password">
                      <el-input v-model="ruleForm.password"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :sm="24" :md="24" :lg="12">
                    <el-form-item label="昵称" prop="nickName">
                      <el-input v-model="ruleForm.nickName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :sm="24" :md="24" :lg="12">
                    <el-form-item label="手机号" prop="phone">
                      <el-input v-model="ruleForm.phone"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>

          <div class="p1" id="a5">
            <div class="header-search">
              <div class="title">
                <el-row>
                  <el-col :span="12">
                    <span class="line"></span>
                    角色配置
                  </el-col>
                </el-row>
                <el-row>
                  <el-col style="display: flex">
                    <span style="margin: 0 20px 0 100px">角色</span>
                    <el-checkbox-group
                      v-model="checkRoleList"
                      @change="roleChange"
                    >
                      <el-checkbox
                        v-for="(item, index) in roleList"
                        :label="item.roleName"
                        :value="item.merchantCode"
                        :key="index"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="header-input"></div>
          </div>
        </div>
        <!-- </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    // 自定义手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^1[34578]\d{9}$/;
      if (regMobile.test(value)) {
        return callback();
      }
      // 返回一个错误提示
      callback(new Error("请输入合法的手机号码"));
    };
    return {
      seeThis: 0,
      tabs: ["基本信息"], //  // "扩展属性",
      // , "与组织的关系", "与岗位的关系", "与权限的关系"
      // "汇报关系",
      ruleForm: {
        loginName: "",
        phone: "",
        nickName: "",
        password: "",
      },
      rules: {},
      roleList: [],
      checkRoleList: [],
      tableData: [],
      id: "",
      userCode: "",
      disabledFalg: false,
      loading: true,
      imageUrl: "",
      userName: "",
      orgTableData: [], //与组织的关系表格数据
      treeData: [], // 组织树形结构数据
      defaultProps: {
        children: "childrens",
        label: "organName",
      },
      defaultKyes: [], //选中节点
      defaultId: "", //当前节点

      queryInfoPost: {
        // 当前页数
        page: 1,
        // 每页显示多少数据
        size: 20,
      },
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {},
      },
      tableData1: [],
    };
  },
  created() {
    if (!this.$route.query.id) {
      this.userCode = this.randomString(11);
      this.disabledFalg = true;
    } else {
      this.userCode = this.$route.query.userCode;
      this.disabledFalg = false;
      this.getDataById();
    }

    // this.userName = JSON.parse(localStorage.getItem("userName"));
    this.getRoleList();
  },
  methods: {
    getRoleList() {
      let that = this;
      that.$http.post("/merchantRole/queryList", {}).then(function (response) {
        console.log(response.data.data);
        if (response.data.code == 200) {
          that.roleList = response.data.data;
        }
      });
    },
    roleChange(e) {
      console.log("选中角色", e);
      // if (e.length > 0) {
      //   const merchantRoles = this.roleList
      //     .filter((item) => this.checkRoleList.includes(item.roleName)) // 过滤出匹配的项
      //     .map((item) => item.merchantCode); // 提取 merchantCode

      //   console.log("选中角色", merchantRoles);
      // }
    },
    goAnchor(index) {
      // 也可以用scrollIntoView方法， 但由于这里头部设置了固定定位，所以用了这种方法
      // document.querySelector('#anchor'+index).scrollIntoView()
      this.seeThis = index;
      var i = index + 1;
      var anchor = this.$el.querySelector("#a" + i);
      this.$nextTick(() => {
        this.$el.querySelector(".menu-content").scrollTop = anchor.offsetTop;
      });
    },
    handleScroll() {
      //console.log("滚动了");
      var scrollTop = this.$el.querySelector(".menu-content").scrollTop;
      var scrollHeight = this.$el.querySelector(".menu-content").scrollHeight;
      var height = this.$el.querySelector(".menu-content").offsetHeight;
      var anchorOffset1 = this.$el.querySelector("#a1").offsetTop;
      var anchorOffset2 = this.$el.querySelector("#a2").offsetTop;
      var anchorOffset3 = this.$el.querySelector("#a3").offsetTop;
      var anchorOffset4 = this.$el.querySelector("#a4").offsetTop;
      var anchorOffset5 = this.$el.querySelector("#a5").offsetTop;
      // var anchorOffset6 = this.$el.querySelector("#a6").offsetTop;
      if (scrollTop > anchorOffset1 && scrollTop < anchorOffset2) {
        this.seeThis = 0;
      }
      if (scrollTop > anchorOffset2 && scrollTop < anchorOffset3) {
        this.seeThis = 1;
      }
      if (scrollTop > anchorOffset3 && scrollTop < anchorOffset4) {
        this.seeThis = 2;
      }
      if (scrollTop > anchorOffset4 && scrollTop < anchorOffset5) {
        this.seeThis = 3;
      }
      if (scrollTop > anchorOffset4) {
        this.seeThis = 4;
      }
      if (scrollTop + height == scrollHeight) {
        this.seeThis = 4;
      }
      // if (scrollTop > anchorOffset5 && scrollTop < anchorOffset6) {
      //   this.seeThis = 4;
      // }
      // if (scrollTop > anchorOffset6) {
      //   this.seeThis = 5;
      // }
      // if (scrollTop + height == scrollHeight) {
      //   this.seeThis = 5;
      // }
    },
    // 表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this;
          // console.log(that.id);

          if (!that.ruleForm.loginName) {
            that.$notify.info({
              title: "提示",
              message: "请输入登录名",
              showClose: true,
            });
            return false;
          }
          if (!that.ruleForm.password) {
            that.$notify.info({
              title: "提示",
              message: "请输入密码",
              showClose: true,
            });
            return false;
          }
          if (!that.ruleForm.nickName) {
            that.$notify.info({
              title: "提示",
              message: "请输入昵称",
              showClose: true,
            });
            return false;
          }

          if (!that.ruleForm.phone) {
            that.$notify.info({
              title: "提示",
              message: "请输入手机号",
              showClose: true,
            });
            return false;
          }

          //   loginName: "",
          // phone: "",
          // nickName: "",
          // password: "",

          var user = that.ruleForm;
          let merchantRoles = [];

          let userInfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
          console.log(userInfo, "-===-=");

          user.merchantCode = userInfo.merchantCode;
          user.merchantName = userInfo.merchantName;
          user.groupCode = userInfo.groupCode;
          user.groupName = userInfo.groupName;

          if (this.checkRoleList.length !== 0) {
            merchantRoles = this.roleList
              .filter((item) => this.checkRoleList.includes(item.roleName)) // 过滤出匹配的项
              .map((item) => {
                return {
                  id: item.id,
                };
              }); // 提取 merchantCode
          } else {
            that.$notify.info({
              title: "提示",
              message: "请选择角色",
              showClose: true,
            });
            return false;
          }
          user.merchantRoles = merchantRoles;
          user.password = that.$md5(user.password);

          if (that.id) {
            user.id = that.id;
          }
          // user.creator = that.userName;
          // user.password = that.$md5(user);
          that.$http
            .post("/merchantUser/save", user)
            .then(function (response) {
              if (response.data.code == 200) {
                that.$notify.success({
                  title: "提示",
                  message: "增加成功",
                  showClose: true,
                });
                that.$router.push({
                  path: "/employeemangent",
                });
              } else {
                // that.ruleForm.password = userPassword;

                that.$notify.info({
                  title: "提示",
                  message: response.data.message,
                  showClose: true,
                });
              }
            })
            .catch(function (error) {
              // that.ruleForm.password = userPassword;
              // that.$notify.info({
              //   title: "提示",
              //   message: e,
              //   showClose: true,
              // });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 监听排序
    sortChange() {},

    //头像
    errorHandler() {
      return true;
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    // 清空
    empty() {
      this.multipleSelection = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    //删除
    del(id, i) {
      this.$refs.tree.setChecked(id);
      this.multipleSelection.splice(i, 1);
    },

    // 根据id获取用户信息
    getDataById() {
      var that = this;
      that.id = that.$route.query.id;
      console.log(that.id);
      if (that.id != undefined || that.id != "") {
        that.$http
          .post("/merchantUser/queryOne", { id: that.id })
          .then(function (response) {
            //console.log(response.data.data);
            if (response.data.code == 200) {
              that.ruleForm = response.data.data;
              if (response.data.data.merchantRoles.length > 0) {
                that.checkRoleList = response.data.data.merchantRoles.map(
                  (item) => {
                    return item.roleName;
                  }
                );
              }
            }
          });
      } else {
      }
    },

    // 获取随机字符串
    randomString(e) {
      e = e || 32;
      var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
      for (var i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
      return n;
    },
  },
  mounted() {
    var that = this;
    this.$el.querySelector(".menu-content").onscroll = () => {
      that.handleScroll();
    }; // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    that.loading = false;
  },
};
</script>

<style lang="less" scope>
.h50 {
  height: 50px;
}

.handle-btn .el-button.add-column-btn {
  width: 100%;
  font-size: 13px;
  background-color: transparent;
  color: #008eff;
  margin-top: -1px;
  position: relative;
  z-index: 100;
}
.employeeDetail {
  .el-breadcrumb__inner {
    color: #2f91df;
  }
  .avatar-uploader {
    top: -16px;
    right: 20px;
    z-index: 10;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .el-row {
    #navigation {
      background-color: #f6f7fb;
      font-size: 14px;
      height: calc(100vh - 110px);
      margin-top: -14px;
      li {
        height: 50px;
        line-height: 50px;
        a {
          display: block;
          color: #324059;
          padding-left: 20px;
          background-color: transparent;
        }
      }
      li.active,
      li:hover {
        background-color: #fff;
      }
    }
    .menu-content {
      height: calc(100vh - 110px);
      overflow-y: auto;
      padding-left: 10px;
      padding-right: 5px;
      .p1 {
        margin-bottom: 20px;
      }
      .header-search {
        .title {
          height: 50px;
          line-height: 49px;
          font-size: 15px;
          color: #2f405b;
          padding-left: 10px;
          border-bottom: 1px solid #e3eaf0;
          margin-bottom: 10px;
          .line {
            display: inline-block;
            width: 3px;
            height: 15px;
            background-color: #2f91df;
            margin-right: 5px;
            border-radius: 2px;
            margin-bottom: -2px;
          }
          .el-input {
            width: 247px;
          }
          .el-input .el-input__inner {
            width: 217px;
          }
        }
      }
      .header-input {
        font-size: 13px;
      }
      .model-mask {
        .el-form {
          .el-form-item {
            margin-bottom: 0;
          }
        }
        .el-table {
          margin-top: 10px;
        }
      }
    }
  }
  #selectorOrgDialog .el-dialog {
    width: 600px !important;
  }
  #selectorOrgDialog .selectedUl {
    height: 350px;
    max-height: 350px;
  }
  #selectorOrgDialog .org-selected .selectedUl-box {
    height: 320px !important;
  }
}
</style>
